import { useProductPageStore } from '../../contexts/ProductPageStore'
import { submitAQuestion } from '../../contexts/fetches/product'
import styles from './qna.module.scss'

import { useContext, useState } from 'react'

import { NotificationContext } from '@speedwaymotors/clutch/Contexts/NotificationContext/NotificationContext'

import { createClickedSegmentEvent } from 'Clutch/Utilities/Instrumentation/Impressions/impressionSegmentEvents'

import Button from 'Clutch/Molecules/Button'

import Typography from 'Clutch/Atoms/Typography'

const AskQuestionForm = ({ onCancel, onSuccess }) => {
  const [questionText, setQuestionText] = useState('')
  const [nickname, setNickname] = useState('')
  const [location, setLocation] = useState('')
  const [submitting, setSubmitting] = useState(false)
  const [email, setEmail] = useState('')
  const [error, setError] = useState(null)

  const skuBaseNumber = useProductPageStore((state) => state.skuBaseNumber)
  const { PushNotification } = useContext(NotificationContext)

  const handleSubmit = async () => {
    if (!questionText.trim()) return
    setSubmitting(true)
    setError(null)
    try {
      await submitAQuestion(`${skuBaseNumber}`, questionText, nickname, email, location)
      setQuestionText('')
      setNickname('')
      setLocation('')
      if (onSuccess) {
        PushNotification('Thank you! Your question has been submitted.', null, 3000, null, {
          icon: 'check',
          intent: 'positive',
        })
        onSuccess()
      }
    } catch (err) {
      console.error('Failed to submit question:', err)
      setError('Failed to submit question. Please try again.')
    } finally {
      setSubmitting(false)
    }
  }

  return (
    <div className={styles.answerFormWrapper}>
      <Typography size="1" font="bold">
        Ask a Question
      </Typography>
      <Typography size="0.75" tone="subtle">
        Fill out the form below to submit your question.
      </Typography>
      <div style={{ display: 'flex' }}>
        <Typography size="0.625" tone="warning">
          *
        </Typography>
        <Typography size="0.625" tone="subtle">
          Required field
        </Typography>
      </div>
      <div className={styles.formField}>
        <label className={styles.formLabel} htmlFor="qna_question">
          <Typography size="0.75" font="bold">
            Question:
          </Typography>
          <Typography size="0.75" font="bold" intent="warning">
            *
          </Typography>
        </label>
        <textarea
          id="qna_question"
          className={styles.formTextarea}
          rows={4}
          value={questionText}
          onChange={(e) => setQuestionText(e.target.value)}
          placeholder="Enter your question..."
        />
      </div>
      <div className={styles.formField}>
        <label className={styles.formLabel} htmlFor="qna_q_nickname">
          <Typography size="0.75" font="bold">
            Nickname:
          </Typography>
          <Typography size="0.75" font="bold" intent="warning">
            *
          </Typography>
        </label>
        <input
          id="qna_q_nickname"
          type="text"
          className={styles.formInput}
          value={nickname}
          onChange={(e) => setNickname(e.target.value)}
          placeholder="Ex. Nancy the Newbie"
        />
      </div>
      <div className={styles.formField}>
        <label className={styles.formLabel} htmlFor="qna_q_location">
          <Typography size="0.75" font="bold">
            Your Location:
          </Typography>
        </label>
        <input
          id="qna_q_location"
          type="text"
          className={styles.formInput}
          value={location}
          onChange={(e) => setLocation(e.target.value)}
          placeholder="Ex. Barstow, CA"
        />
      </div>
      <div className={styles.formField}>
        <label className={styles.formLabel} htmlFor="qna_location">
          <Typography size="0.75" font="bold">
            Email:
          </Typography>
          <Typography size="0.75" font="bold" intent="warning">
            *
          </Typography>
        </label>
        <input
          id="qna_email"
          type="text"
          className={styles.formInput}
          value={email}
          onChange={(e) => setEmail(e.target.value)}
        />
      </div>
      {error && (
        <Typography size="0.75" tone="contrast">
          {error}
        </Typography>
      )}
      <div className={styles.formActions}>
        <Button intent={'subdued'} size={'small'} text={'Cancel'} onClick={onCancel} />
        <Button
          intent={'action'}
          size={'small'}
          text={submitting ? 'Submitting...' : 'Submit'}
          segmentEvent={createClickedSegmentEvent('SubmitQuestion')}
          disabled={!questionText.trim() || !email.trim() || !nickname.trim() || submitting}
          onClick={handleSubmit}
        />
      </div>
    </div>
  )
}

export default AskQuestionForm
